module.exports = __webpack_public_path__ + "img/56.10ec0301.jpg";